<template>
    <div class="home">
        <Map class="home__map"></Map>

        <!-- <Workers class="home__workers"></Workers> -->

    </div>
</template>

<script>
import Map from "@/components/Map"
import Workers from "@/components/Workers"

export default {
    name: "home",
    components: {
        Map,
        Workers
    }
};
</script>

<style lang="scss" scoped>
    .home {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        
        &__map {
            width: 100%;
            max-width: 23.75rem;
            flex: 0 0 23.75rem;
            margin-bottom: 2rem;
            //padding: .5rem;
        }

        &__workers {
            width: 100%;
            max-width: 380px;
            flex: 1;
        }
    }
</style>